export default __webpack_public_path__ + "static/media/question_01.c386c4b5.png";